/* fit-home-ui.js — homepage interactions that survive section swaps.
 *
 * The homepage re-fetches ?sections=home-main-live and replaces that DOM after
 * load. Anything bound with element.addEventListener() inside the section is
 * lost the moment it is replaced, and inline <script> tags never re-execute
 * because innerHTML does not run them. So these handlers are delegated from
 * document, which does not care how often the markup underneath is swapped.
 *
 * Currently: the Best Sellers ALL / UTV / RV filter.
 */
(function () {
  'use strict';

  function filterBestSellers(tab) {
    var scope = document.querySelector('.home-best-sellers');
    if (!scope) return;
    var cards = scope.querySelectorAll('[data-bs-cat]');
    if (!cards.length) return;

    var shown = 0;
    for (var i = 0; i < cards.length; i++) {
      var cat = (cards[i].getAttribute('data-bs-cat') || '').toLowerCase();
      var show = (tab === 'all') || (cat === tab);
      cards[i].style.display = show ? '' : 'none';
      if (show) shown++;
    }
    // Never leave the row empty — fall back to showing everything.
    if (shown === 0) {
      for (var j = 0; j < cards.length; j++) cards[j].style.display = '';
    }
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('[data-tab]') : null;
    if (!btn) return;
    var scope = btn.closest('.home-best-sellers');
    if (!scope) return;

    var tabs = scope.querySelectorAll('[data-tab]');
    for (var i = 0; i < tabs.length; i++) tabs[i].classList.remove('active');
    btn.classList.add('active');

    filterBestSellers((btn.getAttribute('data-tab') || 'all').toLowerCase());
  });
})();
